import api from "./index";

export interface ContractsListParams {
  number?: string;
  companyId?: string;
  responsibleId?: string;
  contractId?: string;
  type?: "contract" | "annex";
  clientId?: string;
  contractorId?: string;
  contractorType?: "juridical" | "physical";
  agentId?: string;
  conditionId?: string;
  isSignedAt?: boolean;
  createdAtMin?: Date;
  createdAtMax?: Date;
  updatedAtMin?: Date;
  updatedAtMax?: Date;
  signedAtMin?: Date;
  signedAtMax?: Date;
  formedAtMin?: Date;
  formedAtMax?: Date;
  isArchive?: boolean;
  archivedAtMin?: Date;
  archivedAtMax?: Date;
  offset?: number;
  limit?: number;
  sort?: "createdAt" | "updatedAt" | "signedAt" | "formedAt" | "number";
  order?: "ASC" | "DESC";
  options?: any;
}

export default (params: ContractsListParams, options?: any) => {
  return api.ContractApi.listShort(
    params.number,
    params.companyId,
    params.responsibleId,
    params.contractId,
    params.type,
    params.clientId,
    params.contractorId,
    params.contractorType,
    params.agentId,
    params.conditionId,
    params.isSignedAt,
    params.createdAtMin,
    params.createdAtMax,
    params.updatedAtMin,
    params.updatedAtMax,
    params.signedAtMin,
    params.signedAtMax,
    params.formedAtMin,
    params.formedAtMax,
    params.isArchive,
    params.archivedAtMin,
    params.archivedAtMax,
    params.offset,
    params.limit,
    params.sort,
    params.order,
    options
  );
};
